import React from "react";
import { cn } from "@/lib/utils";

type Props = {
    noPadding?: boolean;
    className?: string;
    children: React.ReactNode;
};

const Content = ({ children, className, noPadding }: Props) => {
    return (
        <main
            className={cn(
                "bg-white",
                noPadding ? "p-0" : "p-10",
                className
            )}
        >
            {children}
        </main>
    );
};

export default Content;
